import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { renewSession, isSessionExpired } from '@/utils/session'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '',
  timeout: 30000
})

let expiryDialog = null

// 请求拦截器
service.interceptors.request.use(
  config => {
    NProgress.start()
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    // 多租户 Header
    const tenantId = store.getters.tenantId
    if (tenantId) {
      config.headers['__tenant'] = tenantId
    }
    return config
  },
  error => {
    NProgress.done()
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    NProgress.done()
    return response.data
  },
  async error => {
    NProgress.done()
    const { status, data } = error.response || {}

    if (status === 401) {
      const config = error.config
      if (config && !config._sessionRetried) {
        config._sessionRetried = true
        try {
          await renewSession()
        } catch (refreshError) {
          if (!isSessionExpired(refreshError)) {
            Message.error('暂时无法验证登录状态，请稍后重试')
            return Promise.reject(refreshError)
          }
          config._sessionExpired = true
        }
        if (!config._sessionExpired) return service(config)
      }
      if (!expiryDialog) expiryDialog = MessageBox.confirm('登录已过期，请重新登录', '提示', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return store.dispatch('user/logout').then(() => {
          location.reload()
        })
      }).catch(() => {}).finally(() => {
        expiryDialog = null
      })
    } else {
      // ABP 的校验失败统一返回 message="您的请求无效!"，真正的原因在 details 里
      // （形如「The Remark field is required.」），只取 message 会让 400 完全没法定位
      const abpError = (data && data.error) || null
      const msg = (abpError && (abpError.details || abpError.message)) || error.message || '请求失败'
      Message({ message: msg, type: 'error', duration: 3000 })
    }

    return Promise.reject(error)
  }
)

export default service
